const roles = {
	PLANNER: 1,
	ADMIN: 2,
	CONTROLLER: 3,
	SUPERADMIN: 4,
};

export default roles;
